/**
 * Which tickets view the user was last on — the board (`/tickets`) or the
 * register (`/tickets/list`).
 *
 * The "← Tickets" link on a ticket used to be `navigate(-1)`, so it went to
 * whatever page came before: open a ticket from a customer profile, or by URL
 * after visiting Customers, and "Tickets" took you to Customers. The link now
 * always opens a tickets view, and this is how it picks the one you use.
 */
const KEY = 'tickets:last-view';
const VIEWS = ['/tickets', '/tickets/list'] as const;
export type TicketsView = (typeof VIEWS)[number];

export function rememberTicketsView(view: TicketsView): void {
  try {
    sessionStorage.setItem(KEY, view);
  } catch {
    // Storage may be unavailable (private mode); the link falls back to the board.
  }
}

export function lastTicketsView(): TicketsView {
  try {
    const stored = sessionStorage.getItem(KEY);
    return VIEWS.find((v) => v === stored) ?? '/tickets';
  } catch {
    return '/tickets';
  }
}
